import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sms-package-mgr",
  "use": "icon-sms-package-mgr-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sms-package-mgr\"><path d=\"M853.333333 682.666667l-64-34.133334-64 34.133334 64 34.133333L853.333333 682.666667z m21.333334 34.133333l-64 38.4v76.8l64-38.4v-76.8zM768 836.266667v-76.8l-64-38.4v76.8l64 38.4z m85.333333-281.6V324.266667l-315.733333 243.2v4.266666-4.266666L213.333333 324.266667V768h384v42.666667H170.666667V256h725.333333v320l-42.666667-21.333333z m-34.133333-256H247.466667l285.866666 217.6L819.2 298.666667z m-29.866667 298.666666l128 76.8v149.333334l-128 76.8-128-76.8v-149.333334l128-76.8z\" p-id=\"4584\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms-package-mgr.svg
// module id = N104
// module chunks = 115